function eg_dont_auto_add_to_site() {
  // add https://cdn.506.io/eg/script.js?shop=862e0b.myshopify.com to head using a promise that resolves on load
  return new Promise((resolve, reject) => {
    if (window.EasyGiftScriptLoaded) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    if (window.theme.data.customer.id) {
      const { id, tags, ordersCount, totalSpend } = window.theme.data.customer;
      script.src = 'https://cdn.506.io/eg/script.js?shop=' + window.Shopify.shop + '&id=' + id + '&order_count=' + ordersCount + '&total_spent=' + totalSpend + '&tags=' + tags.join(',');
    } else {
      script.src = 'https://cdn.506.io/eg/script.js?shop=' + window.Shopify.shop;
    }
    script.onload = () => window.TitusObjectObserver.observe('EasyGift', window, 50).then(resolve).catch(reject);
    script.onerror = reject;
    document.head.appendChild(script);
  });
};

(function () {
  // exclude on cart page and when it's deactivated in settings
  // we could also lazy load in on cart page, but doesn't seem necessary since that page is not performance critical
  if (!window.theme.settings.egAddToCartOptimize || location.pathname.search(/^\/cart/) > -1) {
    const script = document.createElement('script');
    if (window.theme.data.customer.id) {
      const { id, tags, ordersCount, totalSpend } = window.theme.data.customer;
      script.src = 'https://cdn.506.io/eg/script.js?shop=' + window.Shopify.shop + '&id=' + id + '&order_count=' + ordersCount + '&total_spent=' + totalSpend + '&tags=' + tags.join(',');
    } else {
      script.src = 'https://cdn.506.io/eg/script.js?shop=' + window.Shopify.shop;
    }
    script.defer = 'defer';
    document.head.appendChild(script);
  }

  // fix for dynamic checkout issue => EC-6941
  let ignoreNextDynamicCheckoutCall = false;

  window.TitusObserver.subscribeFetchBefore({
    test: (fetchArgs) => {
      const args = Array.from(fetchArgs);
      const url = args[0].toString()

      if (url.match(/easygift_internal/) || url.match(/graphql\.json\?operation_name=cartQuery$/)) {
        return true;
      }

      return false
    },
    transform: (fetchArgs) => {
      const args = Array.from(fetchArgs);
      const url = args[0].toString()

      if (url.match(/easygift_internal/)) {
        // ignore the next dynamic checkout call => EC-6941
        ignoreNextDynamicCheckoutCall = true;
        return fetchArgs;
      } else if (url.match(/graphql\.json\?operation_name=cartQuery$/) && ignoreNextDynamicCheckoutCall) {
        ignoreNextDynamicCheckoutCall = false;
        return false;
      } else {
        return fetchArgs;
      } 
    }
  });
})()